{
    "$schema": "https://raw.githubusercontent.com/jsonresume/resume-schema/v1.0.0/schema.json",
    "basics": {
        "name": "Jose Vicente Orts Romero",
        "label": "Computer Engineer",
        "image": "",
        "email": "jvortsromero@gmail.com",
        "phone": "",
        "url": "https://app.josrom.io/",
        "summary": "Web developer with extensive experience designing, building and deploying web applications. Active and quick to adapt to any problem solving situation. In my free time I teach myself new languages to keep up with current technologies.",
        "location": {
            "countryCode": "ES",
            "city": "Alicante",
            "region": "Valencian Community"
        },
        "profiles": [
            {
                "network": "LinkedIn",
                "username": "jose-vicente-orts-romero-93aa9990",
                "url": "https://www.linkedin.com/in/jose-vicente-orts-romero-93aa9990/"
            },
            {
                "network": "GitHub",
                "username": "JoseVte",
                "url": "https://github.com/JoseVte"
            }
        ]
    },
    "work": [
        {
            "name": "Square1",
            "position": "Senior Full Stack Developer",
            "startDate": "2023-05-01",
            "endDate": "2026-09-30",
            "summary": "Backend: PHP 7.0 to 8.0 with Laravel and WordPress. Frontend: Vue and Tailwind.",
            "highlights": [
                "API design and maintenance",
                "New features for Laravel web applications",
                "New features and plugins for WordPress",
                "Maintenance and version upgrades"
            ],
            "url": "https://www.linkedin.com/company/3189459",
            "location": "Alicante, Valencian Community, Spain"
        },
        {
            "name": "Square1",
            "position": "Mid-level Full Stack Developer",
            "startDate": "2019-01-01",
            "endDate": "2023-04-30",
            "summary": "Backend: PHP 5.6 to 8.0 with Laravel and WordPress. Frontend: Vue, Tailwind and Bootstrap 3 to 4.",
            "highlights": [
                "API design and maintenance",
                "New features for Laravel web applications",
                "New features and plugins for WordPress",
                "Maintenance and version upgrades"
            ],
            "url": "https://www.linkedin.com/company/3189459",
            "location": "Alicante, Valencian Community, Spain"
        },
        {
            "name": "Square1",
            "position": "Junior Full Stack Developer",
            "startDate": "2016-01-31",
            "endDate": "2018-12-31",
            "summary": "Backend: PHP 5.6 to 7.0 with Laravel and WordPress. Frontend: JavaScript and Bootstrap 3 to 4.",
            "highlights": [
                "API design and maintenance",
                "New features for Laravel web applications",
                "New features and plugins for WordPress",
                "Maintenance and version upgrades"
            ],
            "url": "https://www.linkedin.com/company/3189459",
            "location": "Alicante, Valencian Community, Spain"
        },
        {
            "name": "Square1",
            "position": "Intern",
            "startDate": "2015-08-31",
            "endDate": "2015-12-31",
            "highlights": [],
            "summary": "",
            "url": "https://www.linkedin.com/company/3189459",
            "location": "Alicante, Valencian Community, Spain"
        }
    ],
    "volunteer": [],
    "education": [
        {
            "institution": "Universitat d'Alacant",
            "area": "Computer Engineering",
            "studyType": "Bachelor's degree",
            "startDate": "2011-12-31",
            "endDate": "2016-12-31",
            "score": "",
            "courses": []
        }
    ],
    "awards": [],
    "certificates": [
        {
            "name": "Stripe Certified Professional Developer",
            "issuer": "Stripe",
            "endDate": "2025-05-31",
            "startDate": "2023-05-31",
            "url": "https://stripecertifications.credential.net/78b6d35c-3aa6-4622-8548-e83e90420b14"
        }
    ],
    "publications": [],
    "skills": [
        {
            "name": "PHP",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "JavaScript",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "CSS",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "HTML",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "MySQL",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "Java",
            "level": "Self-taught",
            "keywords": []
        },
        {
            "name": "Laravel",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "WordPress",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "TailwindCSS",
            "level": "5 years",
            "keywords": []
        },
        {
            "name": "Bootstrap",
            "level": "5 years",
            "keywords": []
        },
        {
            "name": "Vue",
            "level": "5 years",
            "keywords": []
        },
        {
            "name": "React",
            "level": "Self-taught",
            "keywords": []
        },
        {
            "name": "Git",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "Linux servers",
            "level": "10 years",
            "keywords": []
        },
        {
            "name": "Docker",
            "level": "5 years",
            "keywords": []
        }
    ],
    "languages": [
        {
            "language": "Spanish",
            "fluency": "Native"
        },
        {
            "language": "Valencian",
            "fluency": "Native"
        },
        {
            "language": "English",
            "fluency": "B2"
        }
    ],
    "interests": [],
    "references": [],
    "projects": [],
    "meta": {
        "version": "v1.0.0",
        "canonical": "https://github.com/jsonresume/resume-schema/blob/v1.0.0/schema.json"
    }
}
